import { injectable, inject } from "inversify";
import type {
  IOdinAdminService,
  OdinContainerSummary,
  OdinAccessSession,
} from "@/interfaces/IOdinAdminService";
import type { IEmploymentHttpClient } from "@/interfaces/IEmploymentService";
import { TYPES } from "@/types";

@injectable()
export class OdinAdminService implements IOdinAdminService {
  private httpClient: IEmploymentHttpClient;

  constructor(
    @inject(TYPES.IEmploymentHttpClient) httpClient: IEmploymentHttpClient
  ) {
    this.httpClient = httpClient;
  }

  async listAllContainers(): Promise<OdinContainerSummary[]> {
    const response = await this.httpClient.post({
      action: "list_all_containers_odin",
      data: {},
    });
    return response.data as OdinContainerSummary[];
  }

  async grantOdinAccess(
    containerId: number,
    reason: string,
    durationHours: number
  ): Promise<void> {
    await this.httpClient.post({
      action: "grant_odin_access",
      data: { containerId, reason, durationHours },
    });
  }

  async revokeOdinAccess(containerId: number): Promise<void> {
    await this.httpClient.post({
      action: "revoke_odin_access",
      data: { containerId },
    });
  }

  async getMyOdinAccess(): Promise<OdinAccessSession[]> {
    const response = await this.httpClient.post({
      action: "get_my_odin_access",
      data: {},
    });
    return response.data as OdinAccessSession[];
  }

  async softDeleteContainer(
    containerId: number,
    confirmName: string
  ): Promise<void> {
    await this.httpClient.post({
      action: "soft_delete_container",
      data: { containerId, confirmName },
    });
  }

  async restoreContainer(containerId: number): Promise<void> {
    await this.httpClient.post({
      action: "restore_container",
      data: { containerId },
    });
  }

  async setExternalViewerEnabled(
    containerId: number,
    enabled: boolean
  ): Promise<void> {
    await this.httpClient.post({
      action: "set_externalViewerEnabled",
      data: { containerId, enabled },
    });
  }
}
